export default {
  MASTER_REASON_MGMT_REQUEST: 'APP/MASTER_REASON_MGMT/MASTER_REASON_MGMT_REQUEST',
  MASTER_REASON_MGMT_SUCCESS: 'APP/MASTER_REASON_MGMT/MASTER_REASON_MGMT_SUCCESS',
  MASTER_REASON_MGMT_ERROR: 'APP/MASTER_REASON_MGMT/MASTER_REASON_MGMT_ERROR',
};
